import { BagPersonalIcon } from './BagPersonalIcon';

/**
 * author: Michael Richins
 * id FB55F27F-9D0D-4EA7-ACD7-22C85E799248
 * name bag-personal
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal.svg
 * tags
 * - Transportation + Flying 
 */
export const BackpackIcon = BagPersonalIcon;
export default BackpackIcon